export { SpaTreatmentsVersion as SpaTreatments } from './SpaTreatmentsVersion';
